// assets/delivery-date-picker.js
document.addEventListener('DOMContentLoaded', function () {
  console.log('[DDP] DOMContentLoaded fired');

  try {
    if (!window.flatpickr) {
      console.error('[DDP] Flatpickr not loaded. Check script order.');
      return;
    }

    const dateInput   = document.getElementById('requested-delivery-date');
    const checkoutBtn = document.getElementById('checkout');

    if (!dateInput || !checkoutBtn) {
      console.warn('[DDP] Missing date input or checkout button; aborting init.');
      return;
    }

    let feedbackEl = document.getElementById('delivery-feedback');
    let saturday_delivery = document.getElementById('saturday_delivery');
    if (!feedbackEl) {
      feedbackEl = document.createElement('div');
      feedbackEl.id = 'delivery-feedback';
      feedbackEl.style.marginTop = '6px';
      feedbackEl.style.fontSize = '0.9rem';
      feedbackEl.style.color = '#444';
      dateInput.parentNode.insertBefore(feedbackEl, dateInput.nextSibling);
    }
 
const BLACKOUTS = [
  '2025-12-23',
  '2025-12-24',
  '2025-12-25',
  '2025-12-26',
  '2025-12-27',
  '2026-01-01',
  '2026-01-02',
  '2026-04-02',
  '2026-04-05',
  '2026-04-06',
  '2026-05-02',
  '2026-05-03',
  '2026-05-04',
  '2026-05-24',
  '2026-05-25',
  '2026-08-30',
  '2026-08-31',
  '2026-12-25',
  '2026-12-26',
  '2026-12-28',
  '2026-12-29',
  '2027-01-01',
  '2027-01-02',
  '2027-03-26',
  '2027-01-04',
  '2027-03-29',
  '2027-03-30',
  '2027-05-03',
  '2027-05-04',
  '2027-05-31',
  '2027-06-01',
  '2027-08-30',
  '2027-08-31',
  '2027-12-24',
  '2027-12-25',
  '2027-12-26',
  '2027-12-27',
  '2027-12-28',
  '2027-12-29',
  '2028-01-01',
  '2028-01-02',
  '2028-01-03',
  '2028-01-04',
    ];
    const blackoutSet = new Set(BLACKOUTS);
    function zeroTime(date) {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    }
function toISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

    // --- NEW HELPER ---
    // Returns the current moment broken down into UK local time fields,
    // regardless of the visitor's own timezone.
    // Intl.DateTimeFormat resolves the IANA timezone 'Europe/London' for us,
    // handling GMT (UTC+0) and BST (UTC+1) transitions automatically.
    function getUKNow() {
      const now = new Date();

      // Extract each field as it appears in UK time
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year:     'numeric',
        month:    'numeric',   // 1–12
        day:      'numeric',   // 1–31
        hour:     'numeric',   // 0–23 (hour12: false)
        hour12:   false,
      }).formatToParts(now);

      // formatToParts returns an array like:
      // [{ type: 'day', value: '24' }, { type: 'month', value: '4' }, ...]
      const p = {};
      parts.forEach(({ type, value }) => { p[type] = parseInt(value, 10); });

      // Reconstruct a plain Date at midnight UK-date in *local* time.
      // We only use this for date arithmetic (adding days), not for
      // displaying times, so the timezone of this Date object doesn't matter —
      // only the year/month/day values do.
      const ukMidnight = new Date(p.year, p.month - 1, p.day, 0, 0, 0, 0);

      return {
        day:        ukMidnight.getDay(),  // 0 Sun … 6 Sat
        hour:       p.hour,               // 0–23 in UK time
        ukMidnight,                       // Date object at midnight of UK's current date
      };
    }

    // computeEarliestAllowed now always operates in UK time
    function computeEarliestAllowed() {
      const { day, hour, ukMidnight } = getUKNow();

      const y = ukMidnight.getFullYear();
      const m = ukMidnight.getMonth();
      const d = ukMidnight.getDate();

      // Friday after 13:00 UK → Tuesday (+4)
      if (day === 5 && hour >= 13) {
        return new Date(y, m, d + 4);
      }
      // Friday before 13:00 UK → Monday (+3)
      if (day === 5) {
        return new Date(y, m, d + 3);
      }

      // Saturday (any time) → Tuesday (+3)
      if (day === 6) {
        return new Date(y, m, d + 3);
      }

      // Sunday (any time) → Tuesday (+2)
      if (day === 0) {
        return new Date(y, m, d + 2);
      }

      // Mon–Thu after 13:00 UK → +2 days
      if (hour >= 13) {
        return new Date(y, m, d + 2);
      }

      // Mon–Thu before 13:00 UK → next day
      return new Date(y, m, d + 1);
    }

    const minDate = computeEarliestAllowed();

    const fp = flatpickr(dateInput, {
      altInput: true,
      altInputClass: 'custom-date-input',
      dateFormat: 'Y-m-d',
      altFormat: 'D, J M Y',
      minDate: minDate,
      allowInput: false,
      disableMobile: true,
      disable: [
        function (date) {
          if (date.getDay() === 0) return true;
          const iso = toISO(date);
          return blackoutSet.has(iso);
        },
      ],
      onChange: function (selectedDates) {
        if (!selectedDates || selectedDates.length === 0) {
          feedbackEl.textContent = '';
          toggleCheckoutButton();
          return;
        }

        const pickedDate = zeroTime(selectedDates[0]);

        // "Tomorrow" must also be calculated in UK time
        const { ukMidnight } = getUKNow();
        const tomorrow = new Date(
          ukMidnight.getFullYear(),
          ukMidnight.getMonth(),
          ukMidnight.getDate() + 1
        );

        if (pickedDate.getDay() === 6) {
          feedbackEl.textContent = "Saturday delivery costs £9.95. If you requested a Saturday on the date picker and do not add this at checkout, your order will be scheduled for the nearest weekday.";
          saturday_delivery.style.display = "block";
        } else if (pickedDate.getTime() === tomorrow.getTime()) {
          feedbackEl.textContent = "Please select 'Next Day Delivery' at checkout";
          saturday_delivery.style.display = "none";
        } else {
          feedbackEl.textContent = "Please select 'Standard Delivery' at checkout";
          saturday_delivery.style.display = "none";
        }

        toggleCheckoutButton();
      }
    });

    function isValidDeliveryDate() {
      const rawValue = dateInput.value;
      if (!rawValue) return false;
      if (rawValue.trim() === 'dd/mm/yyyy') return false;

      const picked = zeroTime(new Date(rawValue));
      if (Number.isNaN(picked.getTime())) return false;

      if (picked.getDay() === 0) return false;
      if (blackoutSet.has(toISO(picked))) return false;

      const earliest = computeEarliestAllowed();
      return picked >= earliest;
    }

    function toggleCheckoutButton() {
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('btn-disabled');
    }

    dateInput.addEventListener('change', toggleCheckoutButton);
    if (fp && fp.altInput) {
      fp.altInput.addEventListener('change', toggleCheckoutButton);
      fp.altInput.addEventListener('input',  toggleCheckoutButton);
    }

    toggleCheckoutButton();

    document.addEventListener('shopify:section:load', toggleCheckoutButton);
    document.addEventListener('shopify:section:render', toggleCheckoutButton);

  } catch (err) {
    console.error('[DDP] Initialisation error:', err);
  }
});